import React from 'react';
import { MessageCircle } from 'lucide-react';
export function FloatingWhatsApp() {
  return <a href="https://wa.me/5491161279601?text=Hola%20Ramón%2C%20quiero%20agendar%20una%20inspección%20técnica%20para%20mi%20equipo" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-whatsapp text-white px-5 py-3 rounded-full shadow-xl hover:scale-105 transition-transform duration-300 group" aria-label="Agendá tu inspección técnica por WhatsApp" data-id="element-64">
      <span className="font-semibold hidden sm:block" data-id="element-65">
        Agendá tu inspección técnica
      </span>
      <MessageCircle className="w-6 h-6" data-id="element-66" />

      {/* Pulse effect */}
      <span className="absolute -inset-1 rounded-full bg-whatsapp opacity-30 group-hover:animate-ping -z-10" data-id="element-67"></span>
    </a>;
}